















































import {
  defineAsyncComponent, defineComponent, computed,
} from '@vue/composition-api';
import { ForceAgreement } from '@hb/coffee-widgets-agreement';
import { Tabs, TabItem } from '@hb/coffee';
import { contractsUrl } from '@/constant';

import type { MoreCapitalResItem, MoreCapitalContract } from '@/api/ordersV2/types';

// 兼容 vue2/vue3 方式
const ForceAgreementView = defineAsyncComponent(() => Promise.resolve(ForceAgreement.view));
export default defineComponent({
  name: 'UndertakeInvestors',
  components: {
    Tabs,
    TabItem,
    ForceAgreementView,
  },
  props: {
    /** 是否展示该组件 */
    show: {
      type: Boolean,
      required: true,
    },
    /** 倒计时 */
    duration: {
      type: Number,
      required: true,
    },
    /** 渠道数据 */
    data: {
      type: Array as () => MoreCapitalResItem[],
      required: true,
    },
    /** 当前选中的资方协议列表 */
    contractList: {
      type: Array as () => MoreCapitalContract[],
      required: true,
    },
    /** 当前选中的资方索引 */
    currentCheckFundIndex: {
      type: Number,
      required: true,
    },
    /** 当前选中的协议索引  TODO: 待组强度件修抛出钩子后接入 */
    currentContractIndex: {
      type: Number,
      required: true,
    },
  },
  emits: ['changeTab', 'update:show', 'confirm'],
  setup(props, context) {
    const contract = computed(() => props.contractList.map((item) => ({
      name: item.name,
      // TODO: 此处目前只展示自营渠道协议 ，自营都是pdf，所以需要拼接pdf_url，后续如果需要展示非自营渠道协议，需要改造此逻辑
      contentUrl: `${contractsUrl || ''}?pdf_url=${item.url}`,
    })));

    /** 由于duration变成0时，强度弹窗重新挂在时还是进行了倒计时，所以需要根据duration动态设置forceReadScene的值
     * TODO: 此处实现需要组件库进行优化处理，目前的处理不合理@俊辉
     */
    const forceReadScene = computed(() => {
      const { duration } = props;
      if (duration > 0) {
        return ['COUNT_DOWN'];
      }
      return [];
    });
    /**
     * 切换渠道
     * @param index 选中的索引
     */
    const onHeaderTabChange = (index:number) => {
      context.emit('changeTab', index);
    };

    const changeContractIndex = (index: number) => {
      context.emit('changeContractIndex', index);
    };

    /**
     * 更新显示状态
     * @param value - 显示状态
     */
    const onUpdateShow = (value:boolean) => {
      context.emit('update:show', value);
    };
    const confirm = () => {
      context.emit('confirm');
    };
    return {
      contract,
      forceReadScene,
      onHeaderTabChange,
      changeContractIndex,
      onUpdateShow,
      confirm,
    };
  },
});
